export class Comune {
  id;
  denominazione;
  tipologia;
  capofila;
  isCapofila;
  dataInizioValidita;
  dataFineValidita;

  ente;
  comuniAssociati;

  utentiOpRef;
  richieste;
}
